var __templateData = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (config, slides, title) {
buf.push("<div id=\"lesson-header\" class=\"block-lg\"> <div id=\"lesson-header-nav\" class=\"text-center\"><div id=\"narration-loader\"></div><div id=\"lesson-header-nav-page-count\"><strong id=\"lesson-header-nav-page-number\" data-testid=\"lesson-header-page-num\">1</strong><span> / </span><!-- Since exit slide is removed, if type of last slide is exit, exclude from total slide count-->");
if ( slides.length>0 && slides[slides.length-1].type==="exit" && config.isQuiz)
{
buf.push("<strong>" + (jade.escape(null == (jade_interp = slides.length-1) ? "" : jade_interp)) + "</strong>");
}
else
{
buf.push("<strong>" + (jade.escape(null == (jade_interp = slides.length) ? "" : jade_interp)) + "</strong>");
}
buf.push("</div>");
if ( config.networkOnline)
{
buf.push("<div id=\"lesson-header-nav-social-learning\" class=\"has-count\"><span class=\"icon icon-chat text-lg\"></span></div>");
}
if ( !config.hideNavMenuBtn)
{
buf.push("<div id=\"lesson-header-nav-menu-btn\"><span class=\"icon icon-menu text-md\"></span></div>");
}
buf.push("</div><div id=\"lesson-header-title\">");
if ( config.logo)
{
buf.push("<img id=\"lesson-header-title-logo\"" + (jade.attr("src", config.logo, true, false)) + "/>");
}
buf.push("<div id=\"lesson-header-title-content\" class=\"text-ellipsis\"><strong>" + (jade.escape(null == (jade_interp = title) ? "" : jade_interp)) + "</strong></div></div></div>");}.call(this,"config" in locals_for_with?locals_for_with.config:typeof config!=="undefined"?config:undefined,"slides" in locals_for_with?locals_for_with.slides:typeof slides!=="undefined"?slides:undefined,"title" in locals_for_with?locals_for_with.title:typeof title!=="undefined"?title:undefined));;return buf.join("");
};
if (typeof define === 'function' && define.amd) {
  define([], function() {
    return __templateData;
  });
} else if (typeof module === 'object' && module && module.exports) {
  module.exports = __templateData;
} else {
  __templateData;
}